/**
 * Sizebay VFR 4.0 — provador virtual e tabela de medidas.
 *
 * O site anterior carregava um "prescript" hospedado pela própria Sizebay
 * (static.sizebay.technology/<tenant>/prescript.js) escrito em cima do DOM da Vnda: ele lia o permalink
 * em `.add-to-cart[data-product-id]`, ancorava os botões em `div.attributes` e ligava os botões
 * "Tabela de Medidas" e "Provador Virtual" do tema aos botões que a Sizebay injeta. Aqui o mesmo
 * contrato é reproduzido no tema, lendo os dados do <script data-sizebay> que o Liquid escreve — assim a
 * integração não depende de um arquivo de terceiro escrito para o DOM de outra plataforma.
 *
 * Dois modos, como no original:
 *   simples  — PDP comum: um provador, ancorado na régua de atributos;
 *   lookbook — PDP de kit: um provador por peça, ancorado dentro de cada peça.
 *
 * O permalink é `<base>/<id da Vnda>`: é essa a chave do catálogo da Sizebay, e ela continua valendo
 * depois da virada porque o domínio é o mesmo. A base fica em Configurações do tema → Integrações.
 *
 * Sem imports: cada arquivo de assets/ tem a sua própria tag (ver docs/04).
 */
(function () {
  var config = null;
  try {
    var tag = document.querySelector('script[data-sizebay]');
    config = tag ? JSON.parse(tag.textContent) : null;
  } catch (e) {
    config = null;
  }
  if (!config || !config.tenant) return;

  var IMPLANTACAO = 'https://vfr-v3-production.sizebay.technology/V4/implantation/index.js';

  var pecas = [].slice.call(document.querySelectorAll('.products [data-kit-item][data-sizebay-permalink]'));
  var lookbook = pecas.length > 0;

  /* Cada modo tem a sua folha de estilo no tenant, e a diferença não é cosmética:
     styles_v4.css esconde `.vfr__container` (quem aparece são os botões do tema, que repassam o clique);
     styles_v4_lookbook.css mostra os botões da Sizebay dentro de cada peça e esconde `div.custom-buttons`.
     É assim que o site atual se comporta. */
  var ESTILO =
    'https://static.sizebay.technology/' +
    config.tenant +
    (lookbook ? '/styles/styles_v4_lookbook.css' : '/styles/styles_v4.css');

  function insereEstilo(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.body.appendChild(link);
  }

  function insereScript(src) {
    if (document.getElementById('szb-vfr__base')) return;
    var s = document.createElement('script');
    s.id = 'szb-vfr__base';
    s.src = src;
    document.head.appendChild(s);
  }

  /** Espera a Sizebay publicar `window.Sizebay.Implantation` e chama `acao`. Desiste em ~30 s. */
  function quandoPronta(acao) {
    var tentativas = 0;
    var timer = setInterval(function () {
      tentativas += 1;
      if (window.Sizebay && typeof window.Sizebay.Implantation === 'function') {
        clearInterval(timer);
        acao();
      } else if (tentativas > 30) {
        clearInterval(timer);
      }
    }, 1000);
  }

  /** Espera um seletor aparecer no DOM (os botões da Sizebay nascem depois da implantação). */
  function quandoExistir(seletor, acao, limite) {
    var tentativas = 0;
    var max = limite || 30;
    var timer = setInterval(function () {
      tentativas += 1;
      var el = document.querySelector(seletor);
      if (el) {
        clearInterval(timer);
        acao(el);
      } else if (tentativas > max) {
        clearInterval(timer);
      }
    }, 1000);
  }

  /**
   * Os botões do tema continuam sendo os visíveis; eles apenas repassam o clique para os da Sizebay,
   * que ficam escondidos pelo CSS do tenant. Se a Sizebay não publicar o provador para este produto
   * (só a tabela de medidas), o "Provador Virtual" some — era o que o prescript anterior fazia.
   */
  function ligaBotoes() {
    quandoExistir('#szb-vfr-button, #szb-measurements-button', function () {
      var vfr = document.querySelector('#szb-vfr-button');
      var medidas = document.querySelector('#szb-measurements-button');
      var botaoMedidas = document.querySelector('#tabelaMedidas');
      var botaoProvador = document.querySelector('#provadorVirtual');

      if (medidas && botaoMedidas) {
        botaoMedidas.addEventListener('click', function (evento) {
          evento.preventDefault();
          medidas.click();
        });
      }
      if (vfr && botaoProvador) {
        botaoProvador.addEventListener('click', function (evento) {
          evento.preventDefault();
          vfr.click();
        });
      } else if (botaoProvador) {
        botaoProvador.style.display = 'none';
      }
    });
  }

  function tamanhos() {
    var valores = [].slice
      .call(document.querySelectorAll('.attributes .option-tamanho input'))
      .map(function (el) { return (el.value || '').trim(); })
      .filter(Boolean);
    return valores.filter(function (v, i) { return valores.indexOf(v) === i; });
  }

  window.SizebayPrescript = function () {
    return {
      getPermalink: function () { return config.permalink; },
      getAnchor: function () { return { web: config.anchor, mobile: config.anchor }; },
      getTenantId: function () { return Number(config.tenant); },
      getButtons: function () {
        if (lookbook) {
          return {
            order: [
              { name: 'vfr', text: config.textoProvador },
              { name: 'measurements', text: config.textoMedidas },
            ],
            position: 'append',
            class: 'vfr__button--clean',
          };
        }
        return {
          order: [{ name: 'vfr', text: null }, { name: 'measurements', text: null }],
          position: 'after',
          class: 'vfr__button--clean',
        };
      },
      getLanguage: function () { return config.lang || 'br'; },
      getRecommendationText: function () { return config.recommendation; },
      getProductSizes: tamanhos,
      hasOnPageIntegration: function () { return !lookbook; },
      getIsMeasurementsTableEnabled: function () { return true; },
    };
  };

  /** Avisa a Sizebay de qual peça foi para o carrinho (alimenta a recomendação de tamanho). */
  function avisaCarrinho(permalink) {
    if (!window.Sizebay || !window.Sizebay.events) return;
    window.Sizebay.events.addToCart({ products: [{ permalink: permalink }] }, Number(config.tenant));
  }

  function modoSimples() {
    quandoPronta(function () {
      window.Sizebay.Implantation({
        permalink: config.permalink,
        tenantId: Number(config.tenant),
        buttons: window.SizebayPrescript().getButtons(),
        anchor: window.SizebayPrescript().getAnchor(),
        lang: window.SizebayPrescript().getLanguage(),
        recommendation: config.recommendation,
      });
      ligaBotoes();

      var comprar = document.querySelector('button.add-to-cart-button');
      if (comprar) {
        comprar.addEventListener('click', function () { avisaCarrinho(config.permalink); });
      }
    });
  }

  function modoLookbook() {
    quandoPronta(function () {
      pecas.forEach(function (peca, i) {
        var alvo = document.createElement('div');
        alvo.id = 'szb-look-' + i;
        // A peça é um grid de 2 colunas; sem isso o provador cairia dentro da coluna da foto (230 px)
        // e os dois botões quebrariam em duas linhas.
        alvo.className = 'kit-sizebay';
        peca.appendChild(alvo);
        window.Sizebay.Implantation({
          permalink: peca.dataset.sizebayPermalink,
          tenantId: Number(config.tenant),
          buttons: window.SizebayPrescript().getButtons(),
          anchor: { web: '#szb-look-' + i, mobile: '#szb-look-' + i },
          lang: window.SizebayPrescript().getLanguage(),
        });
      });

      var comprar = document.querySelector('button.add-to-cart-button');
      if (comprar) {
        comprar.addEventListener('click', function () {
          pecas.forEach(function (peca) {
            if (peca.classList.contains('-kit-selected')) avisaCarrinho(peca.dataset.sizebayPermalink);
          });
        });
      }
    });
  }

  function iniciar() {
    insereEstilo(ESTILO);
    insereScript(IMPLANTACAO);
    if (lookbook) modoLookbook();
    else modoSimples();
  }

  /**
   * Como no tema anterior, a Sizebay só entra depois da primeira interação (ou 6 s no mobile): são
   * ~300 kB de terceiro que não podem competir com a primeira imagem da PDP.
   */
  var iniciado = false;
  function dispara() {
    if (iniciado) return;
    iniciado = true;
    ['mousemove', 'scroll', 'touchstart', 'keydown'].forEach(function (evento) {
      window.removeEventListener(evento, dispara);
    });
    iniciar();
  }
  ['mousemove', 'scroll', 'touchstart', 'keydown'].forEach(function (evento) {
    window.addEventListener(evento, dispara, { once: true, passive: true });
  });
  window.addEventListener('load', function () { setTimeout(dispara, 6000); });
})();
